import { formatPrice } from '@ynap/intl-formatters';
import getLineItem from './getLineItem';
import getPrice from './getPrice';

import { priceFromPriceObj } from '@ynap/price-utils';

export default function getCart(state) {
    const { locale = {}, cart = {} } = state;
    const { orderItem = [], orderItemIncludingRemoved, grandTotal, grandTotalCurrency } = cart;

    const lineItemsIncludingRemoved = orderItemIncludingRemoved
        ? orderItemIncludingRemoved.map((item) => {
              const details = item.removed ? item : orderItem.find(({ partNumber }) => partNumber === item.partNumber);
              const quantityInStock = details.InventoryAvailability.length > 0 ? details.InventoryAvailability[0].onlineInventory : 0;
              const price = details.catalogEntryView && quantityInStock > 0 ? getPrice(details, locale.id) : null;
              return getLineItem(state, details, { inOrder: Math.min(details.quantity, quantityInStock), inStock: quantityInStock }, {}, price, locale);
          })
        : undefined;

    const lineItems = lineItemsIncludingRemoved ? lineItemsIncludingRemoved.filter((item) => item && !item.removed) : undefined;
    return {
        locale,
        lineItems,
        totals: grandTotal
            ? {
                  currency: grandTotalCurrency.label,
                  grandTotal: formatPrice(priceFromPriceObj(grandTotal), grandTotalCurrency.label, locale.id),
              }
            : undefined,
        orderItem,
    };
}

export function getPaymentSystem(state) {
    const {
        cart: { x_paymentSystem = 'GPS' },
    } = state;
    return x_paymentSystem;
}
